import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const NumViews = withDefaultIconProps(
  {
    height: 21,
    width: 22,
    color: theme.colors['surface.tertiary'],
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 22 21">
      <Path
        d="M11.24 11.75C11.93 11.75 12.48 11.2 12.48 10.51C12.48 9.82 11.93 9.26 11.24 9.26C10.55 9.26 9.99 9.82 9.99 10.51C9.99 11.2 10.55 11.75 11.24 11.75Z"
        fill={color}
      />
      <Path
        d="M11.24 6.82C9.21 6.82 7.55 8.47 7.55 10.5C7.55 12.53 9.21 14.18 11.24 14.18C13.27 14.18 14.92 12.53 14.92 10.5C14.92 8.47 13.27 6.82 11.24 6.82ZM11.24 13.12C9.8 13.12 8.62 11.94 8.62 10.5C8.62 9.06 9.8 7.88 11.24 7.88C12.68 7.88 13.85 9.06 13.85 10.5C13.85 11.94 12.68 13.12 11.24 13.12Z"
        fill={color}
      />
      <Path
        d="M16.41 6.07C14.88 5.06 13.09 4.53 11.24 4.53C9.39 4.53 7.6 5.06 6.06 6.07C4.56 7.05 3.38 8.43 2.63 10.05C2.5 10.34 2.5 10.66 2.63 10.95C3.38 12.57 4.56 13.95 6.06 14.93C7.6 15.94 9.39 16.47 11.24 16.47C13.09 16.47 14.88 15.94 16.41 14.93C17.91 13.95 19.1 12.57 19.85 10.95C19.98 10.66 19.98 10.34 19.85 10.05C19.1 8.43 17.91 7.05 16.41 6.07ZM18.88 10.5C18.21 11.94 17.16 13.17 15.83 14.04C14.46 14.93 12.88 15.4 11.24 15.4C9.6 15.4 8.01 14.93 6.65 14.04C5.32 13.17 4.26 11.94 3.6 10.5C3.6 10.5 3.6 10.5 3.6 10.5C4.26 9.06 5.32 7.83 6.65 6.96C8.01 6.07 9.6 5.6 11.24 5.6C12.88 5.6 14.46 6.07 15.83 6.96C17.16 7.83 18.21 9.06 18.88 10.5C18.88 10.5 18.88 10.5 18.88 10.5Z"
        fill={color}
      />
    </Svg>
  ),
);
